import React, { Fragment, useLayoutEffect, useRef } from 'react';
import { translate } from '../Services/translation';
import { tcEventClickSearchSuggestionEvent } from "../Actions/TagCommander.action"

const sameCategory = (item, index, array) => index > 0 && array[index - 1].category === array[index].category || item.showAll;

const QuickSearchResult = ({ result, selectedItem, searchUrl, toggleShowFullForm, searchQuery }) => {    
    const searchResultsRef = useRef(null)

    useLayoutEffect(() => {
        /* Used to calculate inner height of window, since different mobile devices have different ways of handeling inner height and use custom elements that affect the height. For instance iPhone url bar */

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    function handleResize() {
        let vh = window.innerHeight * 0.01;
        searchResultsRef.current.style.setProperty('--results-vh-unit', `${vh}px`);

        if (!searchResultsRef.current) return;
        // We dynamically change the --results-vh-unit custom prop to calculate the correct height for the search results, 
        // since mobile browsers behave very differently, and often change their viewport on scroll, which
        // can cause the cart to be too small or too large.
        vh = window.innerHeight * 0.01;
        searchResultsRef.current.style.setProperty('--results-vh-unit', `${vh}px`);
    }

    return (
        <div className={`quick-search-result`} ref={searchResultsRef}>
            <div className="quick-search-result__header">
                {
                    /* TODO add filter? */
                }
            </div>
            <ul className="quick-search-result__content">
                {result && result.map((item, index, array) => (
                    <Fragment key={`${item.name}-${index}`}>
                        {/* {item.category === 'NoHit' || sameCategory(item, index, array) ? null :
                            <li className="quick-search-result__item quick-search-result__group-header" >{ item.category }</li>
                        } */}
                        {item.download ?
                            <li className={`quick-search-result__item quick-search-result__item--manual ${selectedItem === index ? 'quick-search-result__item--selected' : ''}`} >
                                <div className="quick-search-result__image-container">
                                    <img className="quick-search-result__image" src={item.imageSource} />
                                </div>
                                <div className="quick-search-result__info">
                                    <div className="quick-search-result__name">{item.name}</div>
                                    <div className="quick-search-result__download">
                                        <i className="material-icons">picture_as_pdf</i>
                                        <a href='#' itemProp="url" onClick={e => {e.preventDefault(); toggleShowFullForm(); window.open(item.url, '_blank');}}>{translate('searchresult.downloadmanual')}</a>
                                    </div>
                                </div>
                            </li> :
                            <li className={`quick-search-result__item ${selectedItem === index ? 'quick-search-result__item--selected' : ''}`} >
                                <a className={item.showAll ? 'quick-search-result__show-all' : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'}`}
                                    href={item.showAll ? searchUrl : item.url}
                                    onClick={ () => { tcEventClickSearchSuggestionEvent(searchQuery, item.name) } }>
                                    {
                                        item.hasImage && item.imageSource &&
                                            <div className="quick-search-result__image-container">
                                                <img className="quick-search-result__image" src={item.imageSource} />
                                            </div>
                                    }

                                    <div className="quick-search-result__name">
                                        {item.name}
                                    </div>
                                </a>
                            </li>}
                    </Fragment>
                ))}
            </ul>
            <div className="quick-search-result__footer">
                <button className="button button--big" type="submit">
                    {translate('search.showall')}
                </button>
            </div>
        
        </div>
    )
}

export default QuickSearchResult;